/*
 * Author: harper
 * File Created: Saturday, 23-10-07 11:52 am
 * Last Modified: Thursday, 24-07-25 06:29 pm, by Harper Yan
 * Copyright © 2023 - wello wallet MIT
 */

import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
function Add(props: SvgIconProps) {
  return <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="Add" data-sentry-source-file="index.tsx">
      <path d="M11 13V20H13V13H20V11H13V4H11V11H4V13H11Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="index.tsx" />
    </svg>;
}
export default Add;